var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-control custom-checkbox d-flex"},[_c('input',{staticClass:"custom-control-input",attrs:{"name":_vm.name,"id":_vm.id || _vm.name,"type":"checkbox"},domProps:{"checked":_vm.internalValue},on:{"click":_vm.handleClick}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label my-auto",attrs:{"for":_vm.id || _vm.name}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26edef02","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Checkbox.vue
// module id = null
// module chunks = 